export default [
  {
    prop: 'day',
    label: '日期'
  },
  {
    prop: 'consum_price',
    label: '总消耗'
  },
  {
    prop: 'vat_amount',
    label: '预扣增值税'
  },
  {
    prop: 'super_amount',
    label: '预扣附加税'
  },
  {
    prop: 'iit_amount',
    label: '预扣个税'
  },
  {
    prop: 'pending_price',
    label: '总结算中'
  },
  {
    prop: 'service_price',
    label: '总服务费'
  },
  {
    prop: 'recharge_price',
    label: '总充值'
  },
  {
    prop: 'use_price',
    label: '可用余额'
  },
  {
    prop: 'action',
    label: '操作',
    width: '140px'
  }
]
